import { CascaderContainer } from './containers/CascaderContainer';
import { CascaderStateProvider, CascaderComponentsProvider } from './context';
import type { CascaderOption, CascaderProps } from './types';

// Main component that wraps with providers
export const Cascader = <OptionType extends CascaderOption>({
  components: componentsFromProps,
  ...props
}: CascaderProps<OptionType>) => {
  return (
    <CascaderComponentsProvider components={componentsFromProps}>
      <CascaderStateProvider {...props}>
        <CascaderContainer />
      </CascaderStateProvider>
    </CascaderComponentsProvider>
  );
};
